export function getStatusBgColor(status_text: string) {
  if (
    status_text === '已过期' ||
    status_text === '已失效-额度为0' ||
    status_text === '已失效-保险过期'
  ) {
    return 'rgba(247,152,28,1)'
  } else if (status_text === '无服务') {
    return 'rgba(0,0,0,0.22)'
  }
  return 'rgba(57, 181, 74, 1)'
}
export const insurantTypeOptions = [
  {
    label: '个人身份证',
    value: '1',
  },
  {
    label: '工商注册号',
    value: '3',
  },
  {
    label: '统一社会信用代码',
    value: '2',
  },
]
